var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottomNavLoadIconMobActive = function SvgBottomNavLoadIconMobActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03511 0L0.380737 3.84091L7.03511 7.57512L13.2798 3.84091L7.03511 0Z",
    fill: "#2355FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.159L6.67251 15.9999V8.2061L0 4.47188V12.159Z",
    fill: "#2355FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7429 4.38123L7.39795 8.204V16L14.0523 12.1591L13.7429 4.38123Z",
    fill: "#2355FC"
  })));
};
export default SvgBottomNavLoadIconMobActive;